"use client";

// borrowed from https://github.com/chakra-ui/chakra-ui/blob/9373518ae44d954805e05a482de0eca9ed49e0ba/packages/hooks/src/use-merge-refs.ts
import { RefCallback, RefObject, useMemo } from "react";

type ReactRef<T> = RefCallback<T> | RefObject<T>;

function assignRef<T = any>(ref: ReactRef<T> | null | undefined, value: T) {
  if (ref == null) {
    return;
  }

  if (typeof ref === "function") {
    ref(value);
    return;
  }

  try {
    ref.current = value;
  } catch (e) {
    console.error(e);
    throw new Error(`Cannot assign value '${value}' to ref`);
  }
}

function mergeRefs<T>(...refs: Array<ReactRef<T> | null | undefined>) {
  return (node: T | null) => {
    refs.forEach((ref) => {
      assignRef(ref, node);
    });
  };
}

export function useMergeRefs<T>(...refs: Array<ReactRef<T> | null | undefined>) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => mergeRefs(...refs), refs);
}
